import { useStore } from 'hooks/useStore';
import { useEffect } from 'react';

export const useDrugPortfolio = () => {
  const {
    DrugPortfolioManagementStore: {
      isActiveDrugsLoading,
      isDormantDrugsLoading,
      isInactiveDrugsLoading,
      fetchportfolioDrugs,
      activeDrugs,
      dormantDrugs,
      inactiveDrugs,
    },
  } = useStore();

  useEffect(() => {
    fetchportfolioDrugs();
     
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isActiveDrugsLoading,
    isDormantDrugsLoading,
    isInactiveDrugsLoading,
    activeDrugs,
    dormantDrugs,
    inactiveDrugs,
  };
};
